import { firebase } from '@/api/firebase.js'

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)

const auth = {
  emailLogIn: (email, password) => {
    return firebase
      .auth()
      .signInWithEmailAndPassword(
        email,
        password
      )
  },
  emailSignup: (email, password) => {
    return firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
  },
  currentUser: () => {
    return firebase.auth().currentUser
  },
  logOut: () => {
    return firebase.auth().signOut()
  },
  socialLogin: () => {
    const provider = new firebase.auth.GoogleAuthProvider()

    return firebase
      .auth()
      .signInWithPopup(provider)
  }
}

export { auth as default, auth }
